/* global geotWP */

// prevent scrolling
// document.body.classList.add('modal-open')

const regionModal = document.querySelector('.region-modal')
function showRegionModal(open = true)
{
    if ( open ) {
        regionModal.classList.add('active')
        return
    }
    regionModal.classList.remove('active')
    if ( geotWP.readCookie('geot_country') === null) {
        const defaultISO = regionModal.dataset.iso
        geotWP.createCookie('geot_country', defaultISO, 999);
        // if you use wprocket add this cookie to create different cache based on countries
        geotWP.createCookie('geot_rocket_country', defaultISO, 999);
    }

}


// toggle modal open
document.getElementById('toggle-region-modal').addEventListener('click', e => {
    e.preventDefault()
    showRegionModal()
})

// hide modal if not clicked on __inner part
regionModal.addEventListener('click', () => {
    showRegionModal(false)
})

document.getElementById('region-modal-close').addEventListener('click', () => {
    showRegionModal(false)
})


const regionSelectorsLinks = document.querySelectorAll('.region-modal-selector')

  regionSelectorsLinks.forEach(e => {
        e.addEventListener('click', e => {
            e.preventDefault()

            const iso = e.target.dataset.iso

          // cookie for the plugin and our regular dropdown widget
            geotWP.createCookie('geot_country', iso, 999);
          // if you use wprocket add this cookie to create different cache based on countries
            geotWP.createCookie('geot_rocket_country', iso, 999);

            regionSelectorsLinks.forEach((e) => {
                e.classList.remove('selected')
            })

        e.target.classList.add('selected')
        location.reload();

        })
    })

// check if cookie exist, if not show regional selector modal
if ( geotWP.readCookie('geot_country') === null) {
    showRegionModal()
}
